import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.7998 18.1808L5.00203 22L6.52004 14.3306L0.799805 9.02156L8.53633 8.10061L11.7998 1L15.0633 8.10061L22.7998 9.02156L17.0796 14.3306L18.5976 22L11.7998 18.1808ZM11.7998 15.9635L15.8931 18.263L14.9785 13.6457L18.4222 10.4485L13.7641 9.89414L11.7998 5.61927L9.83555 9.89511L5.17744 10.4485L8.62115 13.6457L7.70649 18.263L11.7998 15.9635Z",
		fill: "currentColor"
	})
});
export default SvgStarOutlined;
